import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Constants } from '@app/constants';
import { UnityDirectMegaMenuService } from '@app/core/services/unity-direct-mega-menu.service';
import { UnityDirectStateService } from '@app/core/services/unity-direct-state.service';

@Component({
  selector: 'app-portal-header',
  templateUrl: './portal-header.component.html'
})
export class PortalHeaderComponent implements OnInit {
  data: string;
  constructor(
    private udStateService: UnityDirectStateService,
    private headerService: UnityDirectMegaMenuService,
    protected htmlSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.headerService.getHeaderForApp().subscribe(
      (data: string) => {
        this.data = data
          .replace(
            `${Constants.appConfiguration.tileImageSVGURL}`,
            './../../../../assets/images/tileImg.svg'
          )
          .replace(
            `${Constants.appConfiguration.dashBoardTilesUnity}`,
            `${Constants.appConfiguration.dashBoardTilesPortal}`
          )
          .replaceAll(
            `${Constants.appConfiguration.tileImagePNGURL}`,
            './../../../../assets/images/default.png'
          );
        this.udStateService.portalHeaderAvailableSubject.next(true);
      },
      error => console.log('Error from backend API', +error)
    );
  }
}
